// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ugpr","footer":"ChangeClinic_footer__1sqVJ"};